import { render, staticRenderFns } from "./CandidateSelectIndex.vue?vue&type=template&id=4204adb8&scoped=true&"
import script from "./CandidateSelectIndex.vue?vue&type=script&lang=js&"
export * from "./CandidateSelectIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4204adb8",
  null
  
)

export default component.exports